import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChart6: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChart6"><Path d="M23 21V19.5H21V3.00098H16V19.5H14.5V8.50098H9.5V19.5H8V14.001H3V19.5H1V21H23Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChart6;
